<script setup>
import BookingForm from '@/Components/BookingForm.vue'
import HeroPanel from '@/Components/HeroPanel.vue'
import BookingInfoContact from '@/Components/BookingInfoContact.vue'
import { useBooking } from '@/Stores/booking.js'
import PromotionalMessage from '@/Components/PromotionalMessage.vue'

const booking = useBooking()
</script>

<template>
	<section class="container relative">
		<div class="flex flex-col lg:rounded-md lg:overflow-hidden sm:flex-row">
			<div
				class="h-[400px] relative w-full overflow-hidden sm:h-auto lg:w-1/2 bg-idrive-dark"
			>
				<HeroPanel />
			</div>
			<div
				id="book-car"
				class="w-full bg-vivid-white px-6 py-6 md:px-8 md:py-10 lg:w-1/2"
			>
				<div class="title pb-2">Book a car now</div>
				<PromotionalMessage />
				<hr class="dotted" />
				<div class="comment-font mt-4 space-y-4">
					<BookingForm />
					<div
						v-if="booking.hasErrors"
						class="mt-4 bg-red-100 p-4 rounded"
					>
						<p class="font-heading">
							{{ booking.getErrors }}
						</p>
					</div>
				</div>

				<BookingInfoContact />
			</div>
		</div>
	</section>
</template>
